import { Link } from 'react-router-dom';

const faqs = [
  {
    question: "Do you offer online counselling?",
    answer: (
      <>
        Yes, secure video sessions are available for clients across{' '}
        <Link to="/tele-health-system" className="text-brand-teal hover:text-brand-teal-dark underline">
          British Columbia
        </Link>.
      </>
    )
  },
  {
    question: "Where is your office?",
    answer: (
      <>
        <Link to="/contact-us" className="text-brand-teal hover:text-brand-teal-dark underline">
          Unit 201, 10366 136A Street, Surrey, BC V3T 1W4
        </Link>, a short walk from Surrey Central SkyTrain.
      </>
    )
  },
  {
    question: "Who do you work with?",
    answer: (
      <>
        <Link to="/services" className="text-brand-teal hover:text-brand-teal-dark underline">
          Individuals, couples, and families
        </Link> seeking help with anxiety, depression, trauma, grief, and relationship concerns.
      </>
    )
  },
  {
    question: "Do you offer affordable counselling options?",
    answer: (
      <>
        Yes! We offer{' '}
        <Link to="/blog/affordable-counselling-services-in-surrey-book-your-60-therapy-session" className="text-brand-teal hover:text-brand-teal-dark underline">
          counselling sessions at $60/hour
        </Link>{' '}
        with student interns supervised by experienced clinical counsellors, making quality mental health care accessible to everyone.
      </>
    )
  },
  {
    question: "Do you accept ICBC claims?",
    answer: (
      <>
        Yes, we offer{' '}
        <Link to="/icbc-coverage-and-other-coverage" className="text-brand-teal hover:text-brand-teal-dark underline">
          direct billing for ICBC claims
        </Link>{' '}
        to support your recovery from motor vehicle accidents.
      </>
    )
  },
  {
    question: "What languages do your counsellors speak?",
    answer: (
      <>
        Our team speaks English, Punjabi, Persian (Farsi), Turkish, Malayalam, Tamil, Spanish, and French (intermediate), providing culturally sensitive care in your preferred language.
      </>
    )
  },
  {
    question: "What are your appointment hours?",
    answer: (
      <>
        We offer flexible daytime and evening appointments to accommodate your schedule. Call{' '}
        <Link to="/contact-us" className="text-brand-teal hover:text-brand-teal-dark underline">
          (604) 619-9992
        </Link>{' '}
        to book.
      </>
    )
  },
  {
    question: "Do you offer couples counselling?",
    answer: (
      <>
        Yes, we provide{' '}
        <Link to="/couples-therapy-marriage-counselling-surrey" className="text-brand-teal hover:text-brand-teal-dark underline">
          couples therapy and marriage counselling
        </Link>{' '}
        to help strengthen relationships through improved communication and understanding.
      </>
    )
  },
  {
    question: "Is counselling covered by insurance?",
    answer: (
      <>
        Many extended health plans cover counselling services. We are registered with{' '}
        <Link to="/icbc-coverage-and-other-coverage" className="text-brand-teal hover:text-brand-teal-dark underline">
          ICBC
        </Link>, First Nations Health Authority (FNHA), and the Crime Victim Assistance Program (CVAP) for direct billing. We can also provide receipts for insurance reimbursement. Contact your insurance provider to confirm your coverage.
      </>
    )
  },
  {
    question: "What should I expect in my first session?",
    answer: (
      <>
        Your first session is an opportunity to share your concerns and goals in a safe, confidential environment. Your counsellor will listen, ask questions to understand your situation, and discuss how they can support you moving forward.
      </>
    )
  },
  {
    question: "Do you offer child counselling?",
    answer: (
      <>
        Yes, we provide{' '}
        <Link to="/child-counselling-services-surrey" className="text-brand-teal hover:text-brand-teal-dark underline">
          specialized child counselling services
        </Link>{' '}
        to support children's emotional well-being and development.
      </>
    )
  },
  {
    question: "What credentials should I look for in a counsellor?",
    answer: (
      <>
        Look for regulated professional designations like RCC (Registered Clinical Counsellor) with the British Columbia Association of Clinical Counsellors, or RSW (Registered Social Worker). Verify credentials through professional regulatory bodies, not through marketing badges or paid award programs.
      </>
    )
  },
  {
    question: "Do you display third-party award badges?",
    answer: (
      <>
        We follow a transparency standard. If an award involves paid promotional packages or paying for a badge or logo, we disclose that and do not use it as proof of clinical quality. We rely on regulated credentials, professional supervision, continuing education requirements, and client outcomes to demonstrate our commitment to quality care.
      </>
    )
  }
];

export default function FAQ() {
  return (
    <>
      <div className="bg-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Frequently Asked Questions About Counselling in Surrey
            </h2>
            <p className="text-lg text-gray-600">
              Quick answers to common questions about our counselling services
            </p>
          </div>

          <div className="space-y-6">
            {faqs.map((faq, index) => (
              <div key={index} className="bg-gray-50 rounded-lg p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-3">
                  {faq.question}
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* JSON-LD Schema Markup */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "name": "Metro Counselling",
          "url": "https://metrocounselling.ca/",
          "telephone": "+1-604-619-9992",
          "email": "info@metrocounselling.ca",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Unit 201, 10366 136A Street",
            "addressLocality": "Surrey",
            "addressRegion": "BC",
            "postalCode": "V3T 1W4",
            "addressCountry": "CA"
          },
          "areaServed": ["Surrey", "Vancouver", "Burnaby", "British Columbia"],
          "sameAs": [
            "https://www.facebook.com/metrocounsellingtherapy/",
            "https://ca.linkedin.com/company/metrocounselling"
          ]
        })
      }} />

      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": [{
            "@type": "Question",
            "name": "Do you offer online counselling?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Yes, we provide secure video sessions for clients across British Columbia."
            }
          },{
            "@type": "Question",
            "name": "Where is your office?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Unit 201, 10366 136A Street, Surrey, BC V3T 1W4, a short walk from Surrey Central SkyTrain."
            }
          },{
            "@type": "Question",
            "name": "Who do you work with?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Individuals, couples, and families seeking help with anxiety, depression, trauma, grief, and relationship concerns."
            }
          },{
            "@type": "Question",
            "name": "Do you offer affordable counselling options?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Yes! We offer counselling sessions at $60/hour with student interns supervised by experienced clinical counsellors, making quality mental health care accessible to everyone."
            }
          },{
            "@type": "Question",
            "name": "Do you accept ICBC claims?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Yes, we offer direct billing for ICBC claims to support your recovery from motor vehicle accidents."
            }
          },{
            "@type": "Question",
            "name": "What languages do your counsellors speak?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Our team speaks English, Punjabi, Persian (Farsi), Turkish, Malayalam, Tamil, Spanish, and French (intermediate), providing culturally sensitive care in your preferred language."
            }
          },{
            "@type": "Question",
            "name": "What are your appointment hours?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "We offer flexible daytime and evening appointments to accommodate your schedule. Call (604) 619-9992 to book."
            }
          },{
            "@type": "Question",
            "name": "Do you offer couples counselling?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Yes, we provide couples therapy and marriage counselling to help strengthen relationships through improved communication and understanding."
            }
          },{
            "@type": "Question",
            "name": "Is counselling covered by insurance?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Many extended health plans cover counselling services. We are registered with ICBC, First Nations Health Authority (FNHA), and the Crime Victim Assistance Program (CVAP) for direct billing. We can also provide receipts for insurance reimbursement. Contact your insurance provider to confirm your coverage."
            }
          },{
            "@type": "Question",
            "name": "What should I expect in my first session?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Your first session is an opportunity to share your concerns and goals in a safe, confidential environment. Your counsellor will listen, ask questions to understand your situation, and discuss how they can support you moving forward."
            }
          },{
            "@type": "Question",
            "name": "Do you offer child counselling?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Yes, we provide specialized child counselling services to support children's emotional well-being and development."
            }
          },{
            "@type": "Question",
            "name": "What credentials should I look for in a counsellor?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Look for regulated professional designations like RCC (Registered Clinical Counsellor) with the British Columbia Association of Clinical Counsellors, or RSW (Registered Social Worker). Verify credentials through professional regulatory bodies, not through marketing badges or paid award programs."
            }
          },{
            "@type": "Question",
            "name": "Do you display third-party award badges?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "We follow a transparency standard. If an award involves paid promotional packages or paying for a badge or logo, we disclose that and do not use it as proof of clinical quality. We rely on regulated credentials, professional supervision, continuing education requirements, and client outcomes to demonstrate our commitment to quality care."
            }
          }]
        })
      }} />
    </>
  );
}
